// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BlogArticleHtmlContent {\n  line-height: 1.5;\n  margin: 0;\n  padding: 0; }\n  .BlogArticleHtmlContent strong {\n    font-family: \"Gotham-Medium\";\n    font-weight: 900; }\n  .BlogArticleHtmlContent a {\n    font-family: \"Gotham-Medium\" !important;\n    color: #000 !important; }\n  @media (max-width: 630px) {\n    .BlogArticleHtmlContent img {\n      width: 80vw !important;\n      height: auto !important; } }\n", ""]);
// Exports
module.exports = exports;
